import { render } from "./ChannelInfoWithHead.vue?vue&type=template&id=885e0d80&scoped=true"
import script from "./ChannelInfoWithHead.vue?vue&type=script&lang=js"
export * from "./ChannelInfoWithHead.vue?vue&type=script&lang=js"

import "./ChannelInfoWithHead.vue?vue&type=style&index=0&id=885e0d80&lang=sass"
import "./ChannelInfoWithHead.vue?vue&type=style&index=1&id=885e0d80&lang=sass&scoped=true"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-885e0d80"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QTooltip,QAvatar,QVirtualScroll,QItem,QItemSection,QItemLabel,QInnerLoading});qInstall(script, 'directives', {Ripple});
